import type { StringGUID } from "@pdfking/tfunc"
import { GuidToString, JSONHash } from "@pdfking/tfunc"

import type { ContentRequest } from "#public"

/** A generated page's identity, known before it is laid out: the
 * FileContentGUID of the plotted page its request makes. */
export const ContentGUID = (request: ContentRequest): StringGUID => GuidToString(JSONHash(request))
